import React from 'react';
import ConfirmDialog from './ConfirmDialog.jsx';
import moment from 'moment';
import ThongTinYeuCauKiemTraDeXuat from './ThongTinYeuCauKiemTraDeXuat.jsx';
import { ShowIf } from 'components/utils';
import {
  DropDownChonCanBoGiaiQuyet,
  DropDownMulipleUse,
  DropDownChonPhongBanThuocCoQuan
} from 'components/tt-forms';
import {TextArea, Text} from 'components/tt-forms/common';
import { GiaiQuyetDonThu } from 'api';
import { Link, browserHistory } from 'react-router';
import {ContainerFileDinhKem} from 'components/upload';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';

const vaiTro = 'CHUYEN_VIEN';
const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'THAM_TRA_XAC_MINH';
const buocGiaiQuyet = null;

class TruongPhongKiemTraDeXuat extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      focused: false,
      id: this.props.id,
      role: this.props.roleGQ,
      validate: false,
      showAttach: false,
      ListTaiLieuVanThu: [],
      ListTaiLieuVanThuShow: [],
      onSave: false,
      yKienGiaiQuyet: '',
      canBoGiaiQuyet: '',
      ngayHetHanGiaiQuyet: '',
      ngayHetHanKTDX: '',
      dataGiaiQuyetDon: [],
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataNextState: [],
      ketLuanNoiDungKhieuNaiGiaoTTXM: '',
      noiDung: '',
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: this.props.coQuanQuanLyNguoiDung,
      nextState: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO',
      dataKiemTraDeXuat: this.props.dataKiemTraDeXuat,
      phongBanChiDinh: ''
    }
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    let dataNextState = [...this.props.dataNextStates];
    let getPhongBan = [...dataNextState].filter(item => item.type === "KTDX_GIAO_PHONG_CUNG_CAP");
    if (getPhongBan.length) {
      let phoPhong = {
        stateId : getPhongBan[0].stateId,
        ten: "Trưởng phòng giao việc phó phòng",
        tenVietTat: "Giao việc phó phòng",
        type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
      }
      dataNextState.push(phoPhong);
    }
    let dataNextStateFilter = [];
    dataNextState.map(item => {
      let newItem = item;
      if (item.type == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
        newItem.tenVietTat = 'Tự xử lý';
        newItem.ten = 'Trưởng phòng tự xử lý';
      }
      dataNextStateFilter[dataNextStateFilter.length] = newItem;
    })
    this.setState({
      dataNextState: dataNextStateFilter,
      dataKiemTraDeXuat: this.props.dataKiemTraDeXuat
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.truongPhongThuHoi == true) {
      if (this.select && prevState.focused == false) {
        this.setState({
          focused: true
        })
        this.select.focus();
      }
    }
  }

  componentWillUnmount() {

  }

  componentWillMount() {
    this.determinativeVaiTro();
  }

  determinativeVaiTro() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (typeof userInfo == 'undefined') {
      browserHistory.push('/');
    } else {
      this.setState({
        donViId: userInfo.donViId
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    let dataNextState = [...nextProps.dataNextStates];
    let dataNextStateFilter = [];
    let getPhongBan = [...dataNextState].filter(item => item.type === "KTDX_GIAO_PHONG_CUNG_CAP");
    let getPhoPhong = [...dataNextState].filter(item => item.type === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG")
    if (!getPhoPhong.length && getPhongBan.length) {
      let phoPhong = {
        stateId : getPhongBan[0].stateId,
        ten: "Trưởng phòng giao việc phó phòng",
        tenVietTat: "Giao việc phó phòng",
        type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
      }
      dataNextState.push(phoPhong);
    }
    dataNextState.map(item => {
      let newItem = item;
      if (item.type == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
        newItem.tenVietTat = 'Tự kiểm tra đề xuất';
        newItem.ten = 'Trưởng phòng tự kiểm tra đề xuất';
      }
      dataNextStateFilter[dataNextStateFilter.length] = newItem;
    })
    this.setState({
      dataNextState: dataNextStateFilter,
      dataKiemTraDeXuat: nextProps.dataKiemTraDeXuat
    })
  }

  onChange(name, e) {
    if (name == 'nextState' && e.target.value == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
      this.setState({
        showAttach: false,
        yKienGiaiQuyet: '',
        canBoGiaiQuyet: '',
        [name]: e.target.value
      }, ()=> {
        this.checkFileRequired();
      })
    } else if (name == 'nextState' && e.target.value != 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
      this.setState({
        yKienGiaiQuyet: '',
        canBoGiaiQuyet: '',
        [name]: e.target.value
      })
    } else {
      this.setState({
        [name]: e.target.value
      })
    }
    if (name== 'nextState') {

    }
    this.props.handleChangeData();
  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,
            phongBanChiDinh: res.data.phongBanGiaiQuyetInfo && res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
            canBoGiaiQuyet: res.data.canBoGiaiQuyetInfo ? res.data.canBoGiaiQuyetInfo.congChucId : '',
            yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',
            ngayHetHanKTDX: res.data.ngayHetHanKTDX ? res.data.ngayHetHanKTDX : '',
            nextState: res.data.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : (res.data.nextStateInfo ? res.data.nextStateInfo.type : (this.props.truongPhongThuHoi == true ? 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' : 'TRUONG_PHONG_GIAO_VIEC_CAN_BO'))
          },() => {
            this.checkOnlyState();
            this.checkFileRequired();
          });
        }
      });
    }
  }

  checkOnlyState() {
    if(this.props.dataNextStates.length == 1) {
      this.setState({
        nextState: this.props.dataNextStates[0].type
      }, ()=> {
        this.checkFileRequired();
      })
    }
  }

  checkFileRequired() {
    let ListTaiLieuVanThu = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(state => {
      return state.nguoiTaoInfo.donViId == this.state.donViId
    });

    let ListTaiLieuVanThuShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(state => {
      return state.nguoiTaoInfo.donViId != this.state.donViId
    });

    if (ListTaiLieuVanThuShow.length > 0) {
      this.setState({
        listTaiLieuVanThuShow: ListTaiLieuVanThuShow
      })
    }

    if(this.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
      let data = [...ListTaiLieuVanThu];
      let dataFilter = data.filter(state => {
        return state.typeRequired == 'BC_KTDX'
      })

      if (dataFilter.length > 0) {
        this.setState({
          listTaiLieuVanThu: ListTaiLieuVanThu,
          showAttachFile: true
        })
      } else {
        let newItem = {
          ten: 'Báo cáo kết quả KTĐX',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'BC_KTDX'
        }
        this.setState({
          listTaiLieuVanThu: [
            ...ListTaiLieuVanThu,
            newItem
          ],
          showAttachFile: true
        })
      }
    }
  }

  onClickClose() {
    this.props.handleBack();
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
    this.props.handleChangeData();
  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
    let params = getParams(dataGiaiQuyetDon, this.state.id);
    let selectedState = this.props.dataNextStates.filter(state => {
      return state.type == this.state.nextState
    });

    if (selectedState.length > 0) {
      params.nextState = {
        id: selectedState[0].stateId
      }
    } else {
      params.nextState = null
    }

    if (this.state.yKienGiaiQuyet) {
      params.yKienGiaiQuyet = this.state.yKienGiaiQuyet
    } else {
      params.yKienGiaiQuyet = null
    }

    if (this.state.canBoGiaiQuyet) {
      params.canBoGiaiQuyet = {
        id: Number(this.state.canBoGiaiQuyet)
      }
    } else {
      params.canBoGiaiQuyet = null
    }

    if (this.state.phongBanChiDinh) {
      params.phongBanGiaiQuyet = {
        id: Number(this.state.phongBanChiDinh)
      };
    }

    if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
      params.phoPhong = true;
    } else {
      params.phoPhong = false;
    }

    return params;
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  handleSave(){
    this.setState({
      onSave: true
    },()=>{

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      let dataFileDelete = [];
      if (this.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
        this.state.dataFileDinhKem.map((item, i) => {
          if (item.taiLieuVanThuId) {
            this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(this.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: this.state.nextState === 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' ? 'KIEM_TRA_DE_XUAT' : loaiQuyTrinh,
              buocGiaiQuyet: buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }
      } else {
        let data = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
        data.filter(state => {
          return state.required && state.typeRequired == 'BC_KTDX'
        }).map((item) => {
          dataFileDelete[dataFileDelete.length] = {
            id: item.taiLieuVanThuId
          }
        });
      }

      let params = this.getParams();
      if (this.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.props.saveGiaiQuyetDon(params, 'gqdLuu');
            });
          });
        });
      } else {
        this.deleteTaiLieuVanThu(dataFileDelete, () => {
          this.props.saveGiaiQuyetDon(params, 'gqdLuu');
        });
      }
    })
  }

  handleGiaiQuyetDon(){
    this.setState({
      onSave: false
    },()=>{
      if (this.validateSubmitForm()) {
        this.setState({
          btnLoading: true
        });
        let dataFileDelete = [];
        if (this.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
          this.state.dataFileDinhKem.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: this.state.nextState === 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' ? 'KIEM_TRA_DE_XUAT' : loaiQuyTrinh,
                buocGiaiQuyet: buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });

          if (this.state.dataTaiLieuVanThuDelete.length > 0) {
            this.state.dataTaiLieuVanThuDelete.map(item => {
              this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
                id: item
              };
            });
          }
        } else {
          let data = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
          data.filter(state => {
            return state.required && state.typeRequired == 'BC_KTDX'
          }).map((item) => {
            dataFileDelete[dataFileDelete.length] = {
              id: item.taiLieuVanThuId
            }
          });
        }

        let _params = this.getParams();
        let params = {};
        let msgName = '';
        let selectedState = this.state.dataNextState.filter(state => {
          return state.type == this.state.nextState
        });

        if (this.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.props.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet
          }
          msgName = 'ktdxTraBaoCao';
        } else if (this.state.nextState === "KTDX_GIAO_PHONG_CUNG_CAP") {
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet,
            phongBanGiaiQuyet: {
              id: Number(this.state.phongBanChiDinh)
            }
          };
          msgName = 'gqdGiaoViec';
        } else  if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
          params = {
            canBoXuLyChiDinh: {
              id: Number(this.state.canBoGiaiQuyet)
            },
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet,
            phoPhong: true,
            phongBanGiaiQuyet: {
              id: Number(this.state.coQuanQuanLyNguoiDung.id)
            }
          }
          msgName = 'gqdGiaoViec';
        } else {
          params = {
            canBoXuLyChiDinh: {
              id: Number(this.state.canBoGiaiQuyet)
            },
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet,
          }
          msgName = 'gqdGiaoViec';
        }
        if (this.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO') {
          this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
            this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
              this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
                this.props.updateGiaiQuyetDon(_params, params, msgName);
              });
            });
          });
        } else {
          this.deleteTaiLieuVanThu(dataFileDelete, () => {
            this.props.updateGiaiQuyetDon(_params, params, msgName);
          });
        }
      }
    })
  }

  onFileChange(data) {
    this.setState ({
      dataFileDinhKem: data
    });
    this.props.handleChangeData();
  }

  onFileRemove(id, data) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });
    this.setState ({
      dataFileDinhKem: data
    });
    this.props.handleChangeData();

  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  openDialog(name) {
    if (this.validateSubmitForm()) {
      this.setState({
        openDialog: true
      })
    }
  }

  closeDialog() {
    this.setState({
      openDialog: false
    })
  }

  onSuccess(name) {
    this.setState({
      openDialog: false
    });
    this.handleGiaiQuyetDon();
  }

  render() {
    let tenCoQuan = (this.props.dataKiemTraDeXuat && this.props.dataKiemTraDeXuat.donViGiaoKTDX) ? this.props.dataKiemTraDeXuat.donViGiaoKTDX.ten : '';
    let lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    return (
      <section className="wrap-block">
        <ThongTinYeuCauKiemTraDeXuat
          listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon}
          {...this.state.dataKiemTraDeXuat}
          hideTable={true}
          donInfo={this.props.donInfo}
          />
        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>
        <ShowIf condition={this.state.nextState != 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO'}>
          <h2 className="title-14 mb15">Thông tin giải quyết</h2>
        </ShowIf>
        <ShowIf condition={this.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO'}>
          <h2 className="title-14 mb15">Báo cáo kết quả kiểm tra</h2>
        </ShowIf>

        <form className="form-action">
          <div className="row pl10 pr10">
            {/* <Text className='col-100 mb10' label='Phòng:' value={typeof this.state.coQuanQuanLyNguoiDung != 'undefined' ? this.state.coQuanQuanLyNguoiDung.ten : ''}/> */}

            <ShowIf condition={this.props.dataNextStates && this.props.dataNextStates.length > 1}>
              <DropDownMulipleUse
                onRef={select => (this.select = select)}
                className="col-25"
                donId={this.state.id}
                require
                isValid={this.state.validate}
                data={this.state.dataNextState}
                keyName='type'
                valueName='tenVietTat'
                label="Hướng giải quyết"
                name="huongGiaiQuyet"
                bindValidator={this}
                selectedValue={this.state.nextState}
                onChange={this.onChange.bind(this, 'nextState')}/>
            </ShowIf>
            <div className='row pl15 pr15'>
              <ShowIf condition={this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG'}>
                <DropDownChonCanBoGiaiQuyet
                  isValid={this.state.validate}
                  selectedValue={this.state.canBoGiaiQuyet}
                  require
                  coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                  vaiTro="PHO_PHONG"
                  bindValidator={this}
                  className="col-25"
                  label="Chọn phó phòng"
                  onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                  name="dropdownChonCanBoGiaiQuyet"
                />
                <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
              </ShowIf>
              <ShowIf condition={this.state.nextState === "KTDX_GIAO_PHONG_CUNG_CAP"}>
               <DropDownChonPhongBanThuocCoQuan
                  require
                  bindValidator={this}
                  selectedValue={this.state.phongBanChiDinh}
                  isValid={this.props.validate}
                  onChange={this.onChange.bind(this, 'phongBanChiDinh')}
                  name="dropdownChonPhongBanThuocCoQuan" />
                <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
              </ShowIf>
              <ShowIf condition={this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO'}>
                <DropDownChonCanBoGiaiQuyet
                  isValid={this.state.validate}
                  selectedValue={this.state.canBoGiaiQuyet}
                  require
                  coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                  vaiTro={vaiTro}
                  bindValidator={this}
                  className="col-25"
                  label="Công chức giải quyết"
                  onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                  name="dropdownChonCanBoGiaiQuyet"
                />

                {/* <div className="col-25">
                  <label className="pt-label">
                    <span className="val-title-bold">Hạn xử lý:</span>
                    <span className="val-content pt17 txt-danger">{this.state.ngayHetHanKTDX ? moment(this.state.ngayHetHanKTDX).format('DD/MM/YYYY') : ''}</span>
                  </label>
                </div> */}
                <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
              </ShowIf>
            </div>
            <ShowIf condition={this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' || this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' || this.state.nextState === "KTDX_GIAO_PHONG_CUNG_CAP" }>
              <div className="col-100 pb5">
                <ContainerFileDinhKem name="TruongPhongGVCB" label="Danh sách văn bản xử lý" hideDescription={true} dataShow={this.props.listTaiLieuVanThuGiaiQuyetDon} disableAttachFile={true}/>
              </div>
            </ShowIf>

            <ShowIf condition={this.state.nextState === 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO' }>
              <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name=""/>
              <ShowIf condition={this.state.showAttachFile}>
                <div className="col-100 pb5">
                  <ContainerFileDinhKem name="CanBoChuyenKQDVG" onSave={this.state.onSave} label="Danh sách văn bản xử lý" bindValidator={this} dataShow={this.state.listTaiLieuVanThuShow} data={this.state.listTaiLieuVanThu} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                </div>
              </ShowIf>
            </ShowIf>
          </div>
          <div className="box-bottom">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
            <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this, 'truongPhongGiaiQuyetDon')}><span>Lưu tạm</span></Link>
            <ShowIf condition={this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO' || this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' || this.state.nextState === "KTDX_GIAO_PHONG_CUNG_CAP"}>
              <Link style={{right: 0}} className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.handleGiaiQuyetDon.bind(this, 'truongPhongGiaiQuyetDon')}><span>Giao việc</span></Link>
            </ShowIf>
            <ShowIf condition={this.state.nextState == 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO'}>
              <Link style={{right: 0}} className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.openDialog.bind(this)}><span>Gửi báo cáo KTĐX</span></Link>
            </ShowIf>
            <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this)} onSuccess={this.onSuccess.bind(this)} title={"Xác nhận giao "+lb1} content={'Bạn có đồng ý chuyển cho ' +tenCoQuan + ' báo cáo kiểm tra và để xuất của đơn/vụ việc này không?'}/>
          </div>
        </form>
      </section>
    );
  }
}

TruongPhongKiemTraDeXuat.defaultProps = {
  validators: {}
}

export default TruongPhongKiemTraDeXuat;



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/TruongPhongKiemTraDeXuat.jsx